import React from 'react'
import Content from '../../../Components/Dashboard/Content/Content'
import CoinSwitchDashboard from '../../../Components/Dashboard/Content/CoinSwitchDashboard'

export default function CoinSwitch() {
    return (
        <Content>
            <CoinSwitchDashboard />
        </Content>
    )
}
